const initialState = {
  mainMenuOpened: true,
  secondaryMenuOpened: false,
  addressModal: '',
  addressModalEditMode: false,
  loadingAddresses: '',
  onTopScroll: true,
  cancelOrderModalOpened: false,
  paymentDataPendingModalOpened: false,
  paymentDataDeniedModalOpened: false,
  modalFaqsOpened: false,
  feedback: undefined,
  feedbackParams: undefined,
  success: undefined,
  formTooltips: {},
  finishedPaymentData: false,
  catalogStepName: null,
};

const initialStateForTest = { ...initialState };

export default initialState;
export { initialStateForTest };
